import { Cell, Pie, PieChart, Tooltip } from 'recharts';

import {
  categoryPercent,
  EstimationVariancePoint,
  VarianceCategory,
} from '@/features/TimeStatsModel';

import { CategoryPieTooltip } from './CategoryPieTooltip';
import { buildCategoryChartData, CATEGORY_COLORS, CATEGORY_LABELS } from './utils';

import s from './TimeEstimationScatterChart.module.scss';

type EstimationVarianceCategoryChartProps = {
  points: EstimationVariancePoint[];
};

export const EstimationVarianceCategoryChart: React.FC<EstimationVarianceCategoryChartProps> = ({
  points,
}) => {
  const { categoryCounts, pieData, totalPlottedTasks } = buildCategoryChartData(points);

  return (
    <div className={s.chart__side}>
      <PieChart width={180} height={180}>
        <Pie data={pieData} dataKey="value" cx="50%" cy="50%" innerRadius={42} outerRadius={80}>
          {pieData.map((item) => (
            <Cell key={item.category} fill={CATEGORY_COLORS[item.category]} />
          ))}
        </Pie>
        <Tooltip
          content={<CategoryPieTooltip />}
          cursor={false}
          offset={8}
          reverseDirection={{ x: true, y: false }}
          allowEscapeViewBox={{ x: true, y: true }}
        />
      </PieChart>
      <div className={s.chart__legend}>
        {(Object.keys(CATEGORY_LABELS) as VarianceCategory[]).map((category) => {
          const count = categoryCounts[category];
          const percent = categoryPercent(count, totalPlottedTasks);

          return (
            <div key={category} className={s.chart__legend_item}>
              <span
                className={s.chart__legend_dot}
                style={{ background: CATEGORY_COLORS[category] }}
              />
              <span>
                {CATEGORY_LABELS[category]}: {count} ({percent.toFixed(1)}%)
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
